import { all } from 'redux-saga/effects';

import cancelarSolicitacaoEmissaoPIDSaga from './cancelarSolicitacao/saga';

export default all([cancelarSolicitacaoEmissaoPIDSaga]);
